import Axios from "axios";
import { Config } from "../constant";
import {
  getChatRoomId,
  getConnectionId,
  send,
  sendWithSession,
  StartTimerForTimeout,
} from "../Socket";
export async function LogAgentRequest(state, found) {
  const logUri = Config.agentRequestLogUri;
  const { name, email, phoneNumber, customFieldsAnswer } = state;
  const result = await Axios.post(logUri, {
    entryPoint: found.entryPointId,
    connectionId: getConnectionId(),
    name,
    email,
    idPel: customFieldsAnswer.idpel,
    phoneNumber,
  });
}
